import callApi from "../../utils/api";
import { API_BASE_URL, json_files } from "../../utils/constants";
import { parseParams } from "../../utils";

const api = callApi(API_BASE_URL || "");

export const IR_COURSE_MAPPING =
  "https://s3.ap-south-1.amazonaws.com/azvasa-lms-cdn-dev-new/IR-SERVICE/configuration/ir-levels-course-assignments.json";

// export const UPLOAD_JSON = '/v1/api/master/ir-grade/upload/{{id}}?{{query}}';
export const UPLOAD_JSON =
  "/v1/api/file/upload-custom/ir?path=IR-SERVICE/configuration";
export const ASSESSMENT_UPLOAD =
  "/v1/api/file/upload-custom?path=IR-SERVICE/ir-assessments";

export const GET_All_GRADES =
  "/v1/api/user/grade-section/grades";

export const GET_LEVELS = "/v1/api/levels";

// Backend endpoint that returns the IR level→course mapping with each
// sub-level's `courseName`/`studentType` appended. Used instead of fetching the
// raw JSON from CloudFront, because already-mapped courses are now excluded from
// the course list and can no longer be resolved to names on the frontend.
export const GET_LEVEL_COURSE_MAPPING = "/v1/api/master/courses/level-mapping";

// NOTE: these custom headers turn the request into a preflighted CORS
// request. The S3 / CloudFront origin must respond to OPTIONS with
// `Access-Control-Allow-Headers: Cache-Control, Pragma, Expires`
// (and the usual Access-Control-Allow-Origin) for these fetches to succeed.
const NO_CACHE_FETCH_OPTIONS = {
  cache: "no-store",
  headers: {
    "Cache-Control": "no-cache, no-store, must-revalidate",
    Pragma: "no-cache",
    Expires: "0",
  },
};

export const getGradeMappingInfo = async () => {
  return await fetch(
    json_files.gradingModels.url,
    NO_CACHE_FETCH_OPTIONS,
  )
    .then((data) => data.json())
    .then((res) => res);
};

export const getCourseMapping = async () => {
  return await fetch(
    IR_COURSE_MAPPING,
    NO_CACHE_FETCH_OPTIONS,
  ).then((data) => data.json().then((res) => res));
};

export const getCourseMappingV2 = async () => {
  // Unwrap the LMSResponse (`api.get` returns the parsed body) so the saga keeps
  // receiving the plain array of levels, same as the old CloudFront fetch did.
  const resp = await api.get(GET_LEVEL_COURSE_MAPPING);
  return resp?.data ?? [];
};

export const getLevels = async (payload) =>
  api.get(parseParams(GET_LEVELS, payload));

export const addLevels = async (payload) => api.post(GET_LEVELS, payload);

export const deleteLevels = async (payload) =>
  api.delete(`${GET_LEVELS}/${payload.id}`);

export const getAllGrades = async () =>
  api.get(GET_All_GRADES);

const jsonUploadParams = new URLSearchParams({
  fileCategory: "IR_SERVICE",
  subFolders: "IR_GRADE",
  fileType: "irGradeList",
});

const assessmentUploadParams = new URLSearchParams({
  fileCategory: "IR_SERVICE",
  subFolders: "IR_GRADE",
  fileType: "irAssessment",
});

export const getById = async (payload) => {
  // console.log(getGradeMappingInfo());
};

export const uploadJson = async (payload) => {
  jsonUploadParams.set("fileType", "irGradeList");
  // if (payload.field && courseFileTypeMap[payload.field]) {
  // }

  return api.post(
    parseParams(UPLOAD_JSON, {
      id: payload.id,
      query: jsonUploadParams.toString(),
    }),
    payload.formData,
    {},
    true,
  );
};

export const uploadAssessment = async (payload) => {
  jsonUploadParams.set("fileType", "irAssessment");
  return api.post(
    parseParams(ASSESSMENT_UPLOAD, {
      id: payload.id,
      query: assessmentUploadParams.toString(),
    }),
    payload.formData,
    {},
    true,
  );
};
